import React, {
	useState,
	useEffect,
	useRef,
	useLayoutEffect,
	memo,
} from "react";
import { gsap } from "gsap";
import Gallery from "./Gallery";

// \n をbrに変換
const convertNewlineToBr = (string: string) => {
	return string.split("\n").map((str: string, index: number) => (
		<React.Fragment key={index}>
			{str}
			<br />
		</React.Fragment>
	));
};

// spec table
type SpecTabelProps = {
	specs: {
		itemSpecTh: string;
		itemSpecTd: string;
	}[];
};
const SpecTabel: React.FC<SpecTabelProps> = (props) => {
	const { specs } = props;
	return (
		<table className="c-item-spec">
			<tbody>
				{specs.map((spec, index) => {
					return (
						<tr key={index}>
							<th>{spec.itemSpecTh}</th>
							<td> {convertNewlineToBr(spec.itemSpecTd)}</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};

// card
type Props = {
	postdata: {
		id: string;
		date: string;
		link: string;
		title: {
			rendered: string;
		};
		acf?: any;
	};
	template_uri: string;
};
const PostCard: React.FC<Props> = (props): JSX.Element => {
	const { id, title, acf } = props.postdata;
	const { itemImgs, itemPrice, itemDesc, itemSpec, itemNotice, itemCode } =
		acf;
	const [btnHtml, setBtnHtml] = useState("");
	const [btnScript, setScript] = useState("");
	const card = useRef(null);

	useEffect(() => {
		gsap.from(card.current, {
			opacity: 0,
			ease: "power3.out",
			duration: 0.5,
		});

		if (itemCode) {
			const tmpStrings = itemCode.replace(/\r?\n/g, "").split("<script>");
			if (tmpStrings[1]) {
				const executeScript = new Function(
					tmpStrings[1].replace("</script>", "")
				);
				executeScript();
			}
			setBtnHtml(tmpStrings[0]);
		}
	}, []);

	return (
		<div id={id} className="c-goods-item" ref={card}>
			<div className="c-goods-item__main">
				<h2 className="c-goods-item__title">{title.rendered}</h2>
				{itemPrice && (
					<div className="c-goods-item__price">
						¥ <span>{Number(itemPrice).toLocaleString()}</span>{" "}
						<small>(税込)</small>
					</div>
				)}
				{itemDesc && (
					<div className="c-goods-item__desc">
						{convertNewlineToBr(itemDesc)}
					</div>
				)}
				{itemSpec && (
					<div className="c-goods-item__spec">
						<SpecTabel specs={itemSpec} />
					</div>
				)}
				{itemNotice && (
					<div className="c-goods-item__notice">
						{convertNewlineToBr(itemNotice)}
					</div>
				)}
				<div
					className="c-goods-item__shopbtn"
					dangerouslySetInnerHTML={{ __html: btnHtml }}
				/>
			</div>
			<div className="c-goods-item__side">
				<div className="c-goods-item__gallery">
					<Gallery images={itemImgs} postId={id} />
				</div>
			</div>
		</div>
	);
};

export default PostCard;
